import { hasWorkspace, isPlatformAdmin, type Impersonation, type Session } from '@/shared/api';

import { paths } from './paths';

/**
 * Waar een ingelogde sessie begint: in de omgeving van het token, of - voor een
 * platformbeheerder zonder omgeving - in het platformbeheer. Zonder omgeving en
 * zonder platformrol is dat het inlogscherm, dat dan de omgevingskeuze toont.
 */
export function homeFor(session: Session | null, impersonation: Impersonation | null): string {
    if (hasWorkspace(session, impersonation)) {
        return paths.dashboard;
    }

    return isPlatformAdmin(session) ? paths.admin : paths.login;
}
